/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!******************************************!*\
  !*** ./scripts/shoe-recommend-single.js ***!
  \******************************************/
var footCalculation = document.querySelector('.calculate-foot-js');
var footMainUrl = footCalculation.querySelector('.shoes-size-url').getAttribute('data-product-url');
var footInput = footCalculation.querySelector('.foot-length-input');
var footInputMax = parseFloat(footInput.getAttribute('max'));
var footInputMin = parseFloat(footInput.getAttribute('min'));
var footSubmit = footCalculation.querySelector('button');
var footError = footCalculation.querySelector('.error');
var footresult = footCalculation.querySelector('.results');
var footPrev = footresult.querySelector('.one-size-prev');
var footCurrent = footresult.querySelector('.one-size-exact');
var footNext = footresult.querySelector('.one-size-next');
footSubmit.addEventListener('click', function (e) {
  var num = footInput.value;
  var number = parseFloat(num);
  if (number < footInputMin && number > footInputMax) {
    footError.classList.remove('hidden');
    footresult.classList.add('hidden');
    footError.innerHTML = "Intervallet b\xF8r v\xE6re mellem ".concat(footInputMin, " og ").concat(footInputMax);
  } else {
    fetch(footMainUrl).then(function (response) {
      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(html, 'text/html');
      var brandName = doc.querySelector('.brand-name');
      var newFootresult = doc.querySelector('.full-data');
      var newFootCurrent = newFootresult.querySelector("[data-size=\"".concat(footInput.value, "\"]"));
      footresult.classList.remove('hidden');
      if (newFootCurrent) {
        footresult.classList.remove('error');
        if (newFootCurrent.getAttribute('data-value') == '-') {
          footresult.classList.add('warn');
          footresult.classList.remove('success');
          footCurrent.innerHTML = "Der blev ikke fundet nogen resultater for l\xE6ngde ".concat(num, " hos ").concat(brandName.innerHTML, ". Pr\xF8v en anden l\xE6ngde mellem ").concat(footInputMin, " og ").concat(footInputMax, ".");
        } else {
          footresult.classList.add('success');
          footresult.classList.remove('warn');
          footCurrent.innerHTML = "Vores eksperter anbefaler st\xF8rrelse ".concat(newFootCurrent.innerHTML, " hos ").concat(brandName.innerHTML, ".");
        }

        // let newFootPrev = newFootCurrent.previousElementSibling;
        // console.log(newFootPrev);
        // footPrev.innerHTML = newFootPrev.innerHTML;

        // let newFootNext = newFootCurrent.nextElementSibling;
        // console.log(newFootNext);
        // footNext.innerHTML = newFootNext.innerHTML;
      } else {
        footresult.classList.remove('success');
        footresult.classList.remove('warn');
        footresult.classList.add('error');
        footCurrent.innerHTML = "Der blev ikke fundet nogen resultater for l\xE6ngde ".concat(num, " hos ").concat(brandName.innerHTML, ". Pr\xF8v en anden l\xE6ngde mellem ").concat(footInputMin, " og ").concat(footInputMax, ".");
      }
    })["catch"](function () {
      footresult.classList.add('hidden');
      console.info('Error In Fetching');
    });
  }
});
/******/ })()
;